const commonStrings = {
  sidebar: {
    logoImageAltText: 'vezeeta logo',
  },

  header: {
    userNameText: 'Hi,',
    logoutText: 'Logout',
  },

  singleFileUploader: {
    attachFiles: 'Attach Files',
  },

  searchProductsAutoComplete: {
    searchProductEnvelopNoResultsText: 'No results found',
    searchProductEnvelopOutOfStockText: 'Out of Stock',
  },
};

export default commonStrings;
